// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10tgj","right":"Footer_right__3dCbh","buttons":"Footer_buttons__1vnVA"};